export default {
  default: () => import("/opt/buildhome/repo/node_modules/.c12/github_GoExpondDev_gx_VbOiz9Kg2G/layouts/default.vue").then(m => m.default || m),
  plain: () => import("/opt/buildhome/repo/node_modules/.c12/github_GoExpondDev_gx_VbOiz9Kg2G/layouts/plain.vue").then(m => m.default || m)
}